/**
 * Microsoft sign-in stays hidden until this flag is turned on.
 * The backend provider list is unchanged. Linked Microsoft accounts
 * still show in Settings so they can be removed.
 */
export const MICROSOFT_SIGN_IN_ENABLED = false;

export function connectProviderIds({ microsoftEnabled = MICROSOFT_SIGN_IN_ENABLED } = {}) {
  const ids = ['google', 'apple'];
  if (microsoftEnabled) ids.push('microsoft');
  return ids;
}
